<template>
  <div class="vkb-nak-svg-trend">
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 32 32" enable-background="new 0 0 56.7 56.7" xml:space="preserve">
      <g v-if="type == 'positiv'">
        <polygon class="cls-1" points="2 30 2 0 0 0 0 32 32 32 32 30 2 30"/>
        <path class="cls-1" d="M8.707,24.707,24,9.41405V12h2V6H20V8h2.58594L7.293,23.293ZM24,8v.001L23.999,8Z"/>
      </g>
      <g v-if="type == 'neutral'">
        <polygon class="cls-1" points="2 30 2 0 0 0 0 32 32 32 32 30 2 30"/>
        <polygon class="cls-1" points="26.763 17.292 28.177 18.706 31.875 15.009 28.219 11.353 26.805 12.767 28.038 14 6 14 6 16 28.055 16 26.763 17.292"/>
      </g>
      <g v-if="type == 'negativ'">
        <polygon class="cls-1" points="2 30 2 0 0 0 0 32 32 32 32 30 2 30"/>
        <polygon class="cls-1" points="22 25 22 27 28 27 28 21 26 21 26 23.586 6.707 4.294 5.293 5.708 24.586 25 22 25"/>
      </g>
    </svg>
  </div>

</template>

<script>
export default {
  name: 'fsoel-icons',
  props: { type: String },
  data() {
    return {};
  },
};
</script>


// WEBPACK FOOTER //
// src/components/common/trend-icons.vue